import MVP from "pages/MVP/MVP";
import ParseTranscript from "pages/ParseTranscript/ParseTranscript";
import NotFound from "pages/NotFound/NotFound";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import { FormatAsTable } from "pages/FormatAsTable/FormatAsTable";
import NewOnboarding from "pages/Onboarding/NewOnboarding";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/dashboard" element={<MVP />} />
        <Route path="/dashboard/:inquiryId" element={<MVP />} />
        <Route path="/onboarding" element={<NewOnboarding />} />
        <Route path="/parse_transcript" element={<ParseTranscript />} />
        <Route path="/format_as_table" element={<FormatAsTable />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
